import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { allEntVistasAction } from '../../ent_vistas/EntVistasAction';
import {
  allEntidadesAction,
  deleteEntidadesAction,
  oneEntidadesAction,
  setActivoEntidadesAction,
} from '../EntidadesAction';
import ExpandedEntidadesComponent from './ExpandedEntidades';

const ListadoEntidades = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [loadingDelete, setloadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [entidad, setEntidad] = React.useState(false);

  // const [rows, setRows] = React.useState([]);

  // React.useEffect(() => {
  //   const fetchData = () => {
  //     const lista = usuariosStore.all.map((el) => {
  //       const entidades = el.entidades.map((ent) => {
  //         if (ent.perfiles.length > 0) {
  //           const perfiles = ent.perfiles.map((per) => per.perfil);
  //           return {
  //             entidad: ent.entidad,
  //             perfiles,
  //           };
  //         } else {
  //           return {
  //             entidad: ent.entidad,
  //             perfiles: [],
  //           };
  //         }
  //       });

  //       const nombreCompleto = `${el.perfil.pnombre} ${
  //         el.perfil.snombre || ''
  //       } ${el.perfil.papellido} ${el.perfil.sapellido || ''}`;
  //       const dni = `${el.perfil.tipoDni}-${el.perfil.dni}`;

  //       return {
  //         ...el,
  //         dni,
  //         nombre: {
  //           nombre: nombreCompleto,
  //           correo: el.correo,
  //         },
  //         rol: {
  //           rol: el.rol,
  //           admin: el.admin,
  //         },
  //         genero: generosEnum[el.perfil.genero],
  //         entidades,
  //         estatus: el.estatus.nombre,
  //         actions: el,
  //         foto: {
  //           nombre: el.perfil.pnombre,
  //           avatar: el.perfil.avatar,
  //         },
  //       };
  //     });

  //     setRows(lista);
  //   };
  //   fetchData();
  // }, [entidadesStore.all]);

  React.useEffect(() => {
    async function fetchData() {
      if (entidadesStore.all && entidadesStore.all.length === 0) {
        await allEntidadesAction(dispatch);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = entidadesStore.all.find((el) => el.id === id);
    await setActivoEntidadesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setloadingDelete(true);
    await deleteEntidadesAction(
      { dispatch, notify },
      entidad.id,
      entidadesStore.params,
    );
    setOpenModalDelete(false);
    setloadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={async () => {
                const data = entidadesStore.all.find(
                  (el) => el.id === tableMeta.rowData[0],
                );
                await setActivoEntidadesAction(dispatch, data);
                history.push(ROUTES.controlEstudios.to);
              }}
            >
              {value}
              {tableMeta.rowData[0] === entidadesStore.activo?.id ?? (
                <Chip
                  label="Administrando"
                  size="small"
                  color="warning"
                  sx={{ ml: 1 }}
                />
              )}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.tipoEntidad.name,
      label: CONST.tipoEntidad.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.suscripciones.name,
      label: CONST.suscripciones.label,
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.map((el) => (
            <>
              <Typography variant="body1">
                {el.fechaInicio} - {el.fechaFinal}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {el.titular.perfil.pnombre} {el.titular.perfil.papellido}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                {el.titular.correo}
              </Typography>
            </>
          ));
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoEntidadesAction(dispatch, value);
                  await oneEntidadesAction(dispatch, tableMeta.rowData[0]);
                  await allEntVistasAction(
                    { dispatch },
                    {
                      idEntidad: tableMeta.rowData[0],
                    },
                  );
                  history.push(ROUTES.panelEntidad.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = entidadesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setEntidad(data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = entidadesStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedEntidadesComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={entidadesStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={entidadesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entidad && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{entidad.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntidades;
